import api from '@/api'
import baseJs from '@/transformer/base'
import constList from '@/store/modules/ConstList'
import { Portofolio } from '@/model/portofolio'

const getDefaultState = () => {
  return {
    portofolios: [],
    portofolio: new Portofolio(),
    infoApiStatus: baseJs.getApiStatusEmpty(),
    listApiStatus: baseJs.getApiStatusEmpty()
  }
}

const mutations = {
  setPortofolios(state, portofolios) {
    state.portofolios = [...portofolios]
  },
  setPortofolio(state, portofolio) {
    state.portofolio = new Portofolio(portofolio)
  },
  setListApiStatus(state, apiStatus) {
    state.listApiStatus = { ...apiStatus }
  },
  setInfoApiStatus(state, apiStatus) {
    state.infoApiStatus = { ...apiStatus }
  }
}

const actions = {
  async getPortofolioList({ commit }) {
    commit('setListApiStatus', baseJs.getApiStatusEmpty())
    this.commit('profile/setProfileApiStatus', baseJs.getApiStatusEmpty())
    this.commit('career/setListApiStatus', baseJs.getApiStatusEmpty())
    try {
      commit('setPortofolios', [])
      this.commit('career/setCareers', [])
      this.commit('career/setCareer_types', [])
      this.commit('profile/setPrefectures', [])
      const res = await api.portofolio.list()
      if (res.list) {
        const portofolioList = []
        res.list.map((portofolio) => {
          portofolioList.push(new Portofolio(portofolio))
        })
        await Promise.all([
          commit('setPortofolios', portofolioList),
          this.commit('career/setCareers', res.careers),
          this.commit('career/setCareer_types', res.career_types),
          this.commit('profile/setPrefectures', res.prefectures)
        ])
      }
      await Promise.all([
        commit('setListApiStatus', baseJs.getApiStatusSuccess()),
        this.commit('profile/setProfileApiStatus', baseJs.getApiStatusSuccess()),
        this.commit('career/setListApiStatus', baseJs.getApiStatusSuccess())
      ])
      return Promise.resolve()
    } catch (err) {
      const errorStatus = baseJs.getErrorStatus(err)
      await commit('setListApiStatus', { ...errorStatus })
      return Promise.reject(err)
    }
  },
  async getPortofolioInfo({ commit }, portofolioId) {
    commit('setInfoApiStatus', baseJs.getApiStatusEmpty())
    try {
      const res = await api.portofolio.info(Number(portofolioId))
      commit('setPortofolio', res.list[0])
      commit('setInfoApiStatus', baseJs.getApiStatusSuccess())
      return Promise.resolve()
    } catch (err) {
      commit('setInfoApiStatus', { ...baseJs.getErrorStatus(err) })
      return Promise.reject(err)
    }
  }
}

const getters = {
  portofoliosForList(state) {
    const arrangedPortofolios = []
    state.portofolios.map((portofolio) => {
      const arrangedPortofolio = Object.assign(portofolio, { isEditable: true })

      if (portofolio.started_at) {
        arrangedPortofolio.started_at = new Date(portofolio.started_at)
      }
      if (portofolio.ended_at) {
        arrangedPortofolio.ended_at = new Date(portofolio.ended_at)
      }
      arrangedPortofolio.is_stopped_arranged = constList.isStoppedStateList[portofolio.is_stopped]
      arrangedPortofolio.achievements.map((e) => {
        return e.achievement_id
      })

      arrangedPortofolio.profile_items = Object.keys(portofolio.profiles)
      arrangedPortofolios.push(arrangedPortofolio)
    })
    return arrangedPortofolios
  },
  portofolioForDetail(state) {
    const achievementIds = state.portofolio.achievements.map((e) => {
      return e.achievement_id
    })
    const additionalParams = {
      achievement_ids: achievementIds,
      profile_items: Object.keys(state.portofolio.profiles),
      isEditable: true
    }
    const portofolio = Object.assign(state.portofolio, additionalParams)

    if (portofolio.started_at) {
      portofolio.started_at = new Date(portofolio.started_at)
    }
    if (portofolio.ended_at) {
      portofolio.ended_at = new Date(portofolio.ended_at)
    }
    return portofolio
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
  getters
}
